

export const useCalcularPrecios = () => {

    const calcularPrecioSoloCantidad = (cantidad, usuario) => {
        const descuentos = [
            { min: 100, descuento: 0.30 },
            { min: 50,  descuento: 0.25 },
            { min: 25,  descuento: 0.20 },
            { min: 13,  descuento: 0.15 },
            { min: 7,   descuento: 0.10 },
            { min: 2,   descuento: 0.05 },
            { min: 0,   descuento: 0 }
        ];

        const { descuento } = descuentos.find(d => cantidad >= d.min);
        const { precioVenta, precioDistri, precioEmpresa, precioPublicista } = usuario;
        
        const cliente = cantidad * precioVenta;
        const distri = cantidad * precioDistri;
        const multiplicador = 1 - descuento;

        return {
            cliente: cliente * multiplicador,
            distri: distri * multiplicador,
            empresa: cantidad * precioEmpresa,
            publicista: cantidad * precioPublicista,
            precioReal: cliente
        };
    };


    const calcularPrecioLitografias = (disenio = '', carrito, cantidad1, terminados) => {
        const cantidad = Number(cantidad1);
        const descuentos = [
            { min: 12, descuento: 0.15 },
            { min: 7,  descuento: 0.10 },
            { min: 4,  descuento: 0.05 },
            { min: 0,  descuento: 0 }
        ];
        
        // Encontrar descuento aplicable
        const { descuento } = descuentos.find(d => cantidad >= d.min);
        const multiplicador = 1 - descuento;
        
        // Precios base del carrito
        const { precioVenta, precioDistri, precioEmpresa, precioPublicista, tipo } = carrito;
        
        // Terminados (usar 0 si no existen)
        const termCliente = terminados?.precioVenta || 0;
        const termDistri = terminados?.precioDistri || 0;
        const termEmpresa = terminados?.precioEmpresa || 0;
        const termPublicista = terminados?.precioPublicista || 0;
        
        // Calcular precios según tipo y diseño
        let cliente, distri, empresa, publicista;
        
        if (disenio === 'Con Diseño') {
            if (tipo === "TARJETAS-VOLANTES-MEMBRETES") {
                cliente = (precioVenta * cantidad) + 12000 + (termCliente * cantidad);
                distri = (precioDistri * cantidad) + 12000 + (termDistri * cantidad);
                empresa = (precioEmpresa * cantidad) + 12000 + (termEmpresa * cantidad);
                publicista = (precioPublicista * cantidad) + 12000 + (termPublicista * cantidad);
            } else if (tipo === "CARPETAS-PLEGABLES") {
                // Fórmula: (precio * cantidad * 1.07) + terminados
                const factorCarpeta = cantidad * 1.07;
                cliente = (precioVenta * factorCarpeta) + termCliente;
                distri = (precioDistri * factorCarpeta) + termDistri;
                empresa = (precioEmpresa * factorCarpeta) + termEmpresa;
                publicista = (precioPublicista * factorCarpeta) + termPublicista;
            } else {
                // Caso por defecto para otros tipos con diseño
                cliente = (precioVenta * cantidad) + termCliente;
                distri = (precioDistri * cantidad) + termDistri;
                empresa = (precioEmpresa * cantidad) + termEmpresa;
                publicista = (precioPublicista * cantidad) + termPublicista;
            }
        } else {
            // Sin diseño
            cliente = (precioVenta * cantidad) + termCliente;
            distri = (precioDistri * cantidad) + termDistri;
            empresa = (precioEmpresa * cantidad) + termEmpresa;
            publicista = (precioPublicista * cantidad) + termPublicista;
        }
        
        // Aplicar descuento solo a cliente y distribuidor
        return {
            cliente: cliente * multiplicador,
            distri: distri * multiplicador,
            empresa,
            publicista,
            precioReal: cliente
        };
    };




    const calcularPreciosTerminados = (unidadMedida, alto1 = 0, ancho1 = 0, cantidad1 = 0, carrito, terminados) => {
        const alto = Number(alto1);
        const ancho = Number(ancho1);
        const cantidad = Number(cantidad1);
        
        const descuentos = [
            { min: 100, descuento: 0.30 },
            { min: 50,  descuento: 0.25 },
            { min: 25,  descuento: 0.20 },
            { min: 13,  descuento: 0.15 },
            { min: 7,   descuento: 0.10 },
            { min: 2,   descuento: 0.05 },
            { min: 0,   descuento: 0 }
        ];
        
        const { descuento } = descuentos.find(d => cantidad >= d.min);
        const multiplicador = 1 - descuento;
        const { precioVenta, precioDistri, precioEmpresa, precioPublicista } = carrito;
        
        // Terminados con optional chaining
        const termCliente = terminados?.precioVenta || 0;
        const termDistri = terminados?.precioDistri || 0;
        const termEmpresa = terminados?.precioEmpresa || 0;
        const termPublicista = terminados?.precioPublicista || 0;
        
        // Factor de conversión según unidad de medida
        const factorConversion = unidadMedida === 'Centimetros' ? 0.0001 : 1;
        
        // Cálculo del área (optimizado: una sola operación)
        const area = alto * ancho * cantidad * factorConversion;
        
        // Cálculo de terminados por cantidad (precalculado)
        const termClienteCant = termCliente * cantidad;
        const termDistriCant = termDistri * cantidad;
        const termEmpresaCant = termEmpresa * cantidad;
        const termPublicistaCant = termPublicista * cantidad;
        
        // Cálculo de precios base
        const cliente = (area * precioVenta) + termClienteCant;
        const distri = (area * precioDistri) + termDistriCant;
        const empresa = (area * precioEmpresa) + termEmpresaCant;
        const publicista = (area * precioPublicista) + termPublicistaCant;
        
        // Aplicar descuento solo a cliente y distribuidor
        return {
            cliente: cliente * multiplicador,
            distri: distri * multiplicador,
            empresa,
            publicista,
            precioReal: cliente
        };
    };

    

    const calcularPrecioX50U = (cantidad, carrito) => {
        const descuentos = [
            { min: 1000, descuento: 0.30 },
            { min: 751,  descuento: 0.25 },
            { min: 501,  descuento: 0.20 },
            { min: 301,  descuento: 0.15 },
            { min: 101,  descuento: 0.10 },
            { min: 51,   descuento: 0.05 },
            { min: 0,    descuento: 0 }
        ];

        // Encontrar el descuento aplicable
        const { descuento } = descuentos.find(d => cantidad >= d.min);
        const multiplicador = 1 - descuento;
        const { precioVenta, precioDistri, precioEmpresa, precioPublicista } = carrito;
        const cliente = cantidad * precioVenta;
        const distri = cantidad * precioDistri;

        return {
            cliente: cliente * multiplicador,
            distri: distri * multiplicador,
            empresa: cantidad * precioEmpresa,
            publicista: cantidad * precioPublicista,
            precioReal: cliente
        };
    };




    const calcularCantidadx10U = (cantidad, carrito) => {
        const descuentos = [
            { min: 100, descuento: 0.30 },
            { min: 51,  descuento: 0.25 },
            { min: 41,  descuento: 0.20 },
            { min: 31,  descuento: 0.15 },
            { min: 21,  descuento: 0.10 },
            { min: 11,  descuento: 0.05 },
            { min: 0,   descuento: 0 }
        ];

        // Encontrar el descuento aplicable
        const { descuento } = descuentos.find(d => cantidad >= d.min);
        const multiplicador = 1 - descuento;
        const { precioVenta, precioDistri, precioEmpresa, precioPublicista } = carrito;
        const cliente = cantidad * precioVenta;
        const distri = cantidad * precioDistri;

        // Aplicar descuento solo a cliente y distribuidor
        return {
            cliente: cliente * multiplicador,
            distri: distri * multiplicador,
            empresa: cantidad * precioEmpresa,
            publicista: cantidad * precioPublicista,
            precioReal: cliente
        };
    };
























    return {
        calcularPrecioSoloCantidad,
        calcularPrecioX50U,
        calcularCantidadx10U,
        calcularPreciosTerminados,
        calcularPrecioLitografias
    }


}















































